const serverNavigate = (path: string) => {
  window.location.href = path
}

export default serverNavigate
